import { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import routes from 'app/routes';

export default function useReportContents({ enterpriseId }) {
  const [reportContents, setReportContents] = useState(null);

  const [shouldRefetch, setRefresh] = useState({});

  const refresh = () => {
    setRefresh({});
  };

  useEffect(() => {
    const params = {};
    if (enterpriseId !== null) {
      params.enterprise_id = enterpriseId;
    }

    axios
      .get(routes.api.report_contents.index, { params })
      .then((response) => {
        setReportContents(response.data.data);
      });
  }, [enterpriseId, shouldRefetch]);

  return [reportContents, refresh];
}

useReportContents.propTypes = {
  enterpriseId: PropTypes.number,
};

useReportContents.defaultProps = {
  enterpriseId: null,
};
